import { Routes } from '@angular/router';
import { createAuthGuard } from '@core/auth';
import { userRightsLoaderGuard } from '@core/user';
import { AuthenticatedLayoutComponent } from './authenticated-layout.component';
import { AppShellComponent } from './app/app-shell.component';
import { impersonationGuard } from '../features/support/impersonation/impersonation.guard';
import { LOCAL_SALVAGE_BID_PATH } from '../features/local-salvage-bid/models/local-salvage-offer.model';
import { APP_UPDATE_RELOAD_PATH } from '../features/app-updates/models/app-updates.model';
import { AppUpdateReloadPageComponent } from '../features/app-updates/components/app-update-reload-page.component';

export const ROOT_ROUTES: Routes = [
  {
    path: 'signin-callback',
    loadComponent: () =>
      import('@core/auth/oauth/signin-callback.component').then(
        (m) => m.SigninCallbackComponent
      ),
  },
  {
    path: `${LOCAL_SALVAGE_BID_PATH}/:code`,
    title: 'Restwertanfrage',
    loadComponent: () =>
      import('../features/local-salvage-bid/local-salvage-bid-page.component').then(
        (m) => m.LocalSalvageBidPageComponent
      ),
  },
  {
    path: APP_UPDATE_RELOAD_PATH,
    component: AppUpdateReloadPageComponent,
  },
  {
    path: '',
    component: AuthenticatedLayoutComponent,
    canActivate: [createAuthGuard()],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'app',
      },
      {
        path: 'impersonate',
        title: 'Impersonierung',
        loadComponent: () =>
          import('../features/support/impersonation/impersonation-page.component').then(
            (m) => m.ImpersonationPageComponent
          ),
        canActivate: [impersonationGuard],
      },
      {
        path: 'unavailable',
        title: 'Server nicht erreichbar',
        loadComponent: () =>
          import('@core/error-handling/components').then(
            (m) => m.ServerUnavailablePageComponent
          ),
      },
      {
        path: 'app',
        component: AppShellComponent,
        canActivate: [userRightsLoaderGuard],
        loadChildren: () =>
          import('./app/app.routes').then((m) => m.APP_ROUTES),
      },
    ],
  },
];
